<template>
    <div id="input-stock-articles-page">
        <h1>{{ trans('pages.input_stock_articles_page.title') }}</h1>
        <div>
            <ui5-file-uploader
                @change="fileAdded"
                :disabled="uploading"
                :placeholder="
                    trans(
                        'pages.input_stock_articles_page.file_upload.placeholder'
                    )
                "
                accept=".zip"
                multiple="false"
            >
                <ui5-button icon="upload">
                    {{
                        trans(
                            'pages.input_stock_articles_page.file_upload.button'
                        )
                    }}
                </ui5-button>
            </ui5-file-uploader>
            <div v-if="uploading">
                <spinner-text>
                    {{
                        trans(
                            'pages.input_stock_articles_page.upload_progress',
                            { filename: file.name }
                        )
                    }}
                </spinner-text>
            </div>
            <div
                v-if="error"
                class="error"
            >
                {{ error }}
            </div>
            <div
                v-if="success"
                class="success"
            >
                {{
                    trans('pages.input_stock_articles_page.upload_success', {
                        filename: file.name,
                    })
                }}
            </div>
        </div>
        <div
            v-if="results"
            v-for="item in results"
            :key="item.file"
            class="upload-item"
        >
            <img
                :src="
                    item.uploadSuccess ? 'images/done.png' : 'images/error.png'
                "
            />
            <div>
                <span>{{ item.file }} &#8680;</span>
                <span
                    v-if="item.uploadSuccess"
                    class="success"
                >
                    <span>{{ item.profile.code }}</span>
                    <span
                        v-if="
                            item.profile.description &&
                            item.profile.description.length
                        "
                    >
                        -
                    </span>
                    <span>{{ item.profile.description }}</span>
                </span>
                <span
                    v-else
                    class="error"
                >
                    {{ getError(item) }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import profileApi from '../api/profile';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            uploading: false,
            file: null,
            error: null,
            success: false,
            results: null,
        };
    },
    methods: {
        getError(item) {
            if (!item.isImageFile) {
                return this.trans(
                    'pages.input_stock_articles_page.errors.not_image'
                );
            }
            if (!item.profile) {
                return this.trans(
                    'pages.input_stock_articles_page.errors.article_not_exists'
                );
            }
            if (!item.resizeSuccess) {
                return this.trans(
                    'pages.input_stock_articles_page.errors.resize_failed'
                );
            }
            if (!item.uploadSuccess) {
                return this.trans(
                    'pages.input_stock_articles_page.errors.s3_upload_failed'
                );
            }
        },
        uploadFile() {
            this.uploading = true;
            this.success = false;
            profileApi
                .uploadImageZip(
                    this.file,
                    this.$store.getters['currentUser/getUserId']
                )
                .then((response) => {
                    this.success = true;
                    this.results = response.data.data;
                })
                .catch((error) => {
                    this.error = error.response.data.data;
                })
                .finally(() => {
                    this.uploading = false;
                });
        },
        fileAdded(event) {
            const files = event.target.files;
            const file = files[0];
            if (file.type == 'application/zip') {
                this.file = file;
                this.uploadFile();
            }
        },
    },
    mounted() {},
};
</script>
